export enum ProjectLocationTypes {
  GET_PROJECT_LOCATIONS = 'GET_PROJECT_LOCATIONS',
  GET_PROJECT_LOCATIONS_CANCEL = 'GET_PROJECT_LOCATIONS_CANCEL',
  GET_PROJECT_LOCATIONS_SUCCESS = 'GET_PROJECT_LOCATIONS_SUCCESS',
}
